module.exports = __webpack_public_path__ + "static/img/02.a3ff28df.gif";